export default "__VITE_ASSET__CY89pitY__"